<mat-dialog-content>
  <div class="text-black dark:!text-white p-2">
    <div class="absolute right-4 top-4">
      <button (click)="closeDialog()" mat-button class="font-bold rounded">
        &#x2715;
      </button>
    </div>
    <h3 class="mt-3 mb-4 text-lg leading-tight font-bold text-center text-gray-900 dark:text-white">
      Announcing a Unified Account System Across All Teuteuf Games
    </h3>
    <div class="mb-4 flex flex-col text-sm text-gray-900 dark:text-white gap-2">
      <div class="text-sm">We've updated our accounts system! You can now:</div>
      <div class="flex flex-col">
        <div class="flex gap-2 items-center">
          <svg class="!w-[24px] h-[24px] " viewBox="0 0 24 24" width="24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6 21V19C6 17.9391 6.42143 16.9217 7.17157 16.1716C7.92172 15.4214 8.93913 15 10 15H14C15.0609 15 16.0783 15.4214 16.8284 16.1716C17.5786 16.9217 18 17.9391 18 19V21M8 7C8 8.06087 8.42143 9.07828 9.17157 9.82843C9.92172 10.5786 10.9391 11 12 11C13.0609 11 14.0783 10.5786 14.8284 9.82843C15.5786 9.07828 16 8.06087 16 7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div class="text-sm">Manage your account for all Teuteuf games in one place.</div>
        </div>
        <div class="flex gap-2 items-center">
          <svg class="!w-[24px] h-[24px] " viewBox="0 0 24 24" width="24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6 12H10M8 10V14M15 11V11.01M18 13V13.01M2 8C2 7.46957 2.21071 6.96086 2.58579 6.58579C2.96086 6.21071 3.46957 6 4 6H20C20.5304 6 21.0391 6.21071 21.4142 6.58579C21.7893 6.96086 22 7.46957 22 8V16C22 16.5304 21.7893 17.0391 21.4142 17.4142C21.0391 17.7893 20.5304 18 20 18H4C3.46957 18 2.96086 17.7893 2.58579 17.4142C2.21071 17.0391 2 16.5304 2 16V8Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div class="text-sm">
            Access all our games from the{{" "}}
            <a
              href="https://account.teuteuf.fr/#games"
              target="blank"
              rel="noreferrer"
              class="underline text-blue-500 hover:text-blue-600 text-sm"
            >
              My Games</a>
            {{" "}}page.
          </div>
        </div>
        <div class="flex gap-2 items-center">
          <svg class="!w-[24px] h-[24px] " viewBox="0 0 24 24" width="24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.5 21H6C5.46957 21 4.96086 20.7893 4.58579 20.4142C4.21071 20.0391 4 19.5304 4 19V7C4 6.46957 4.21071 5.96086 4.58579 5.58579C4.96086 5.21071 5.46957 5 6 5H18C18.5304 5 19.0391 5.21071 19.4142 5.58579C19.7893 5.96086 20 6.46957 20 7V10M16 3V7M8 3V7M4 11H16M20 14L22 16M22 16H19C18.5137 16 18.0347 16.1182 17.6042 16.3444C17.1738 16.5707 16.8047 16.8982 16.529 17.2987C16.2532 17.6992 16.0789 18.1608 16.0212 18.6437C15.9634 19.1265 16.0239 19.6162 16.1974 20.0705C16.3709 20.5248 16.6523 20.9301 17.0173 21.2514C17.3822 21.5728 17.8198 21.8007 18.2924 21.9154C18.765 22.0301 19.2584 22.0281 19.73 21.9098C20.2017 21.7914 20.6375 21.5602 21 21.236M22 16L20 18"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div class="text-sm">
            Select from a new set of plans for a premium, ad-free
            experience.
          </div>
        </div>
      </div>
    </div>
    <div class="w-full flex flex-col justify-center items-center gap-2">
      <a href="https://account.teuteuf.fr/" target="_blank" rel="noreferrer"
        class="inline-flex items-center justify-center w-full h-[35px] px-2 py-1.5 text-sm font-semibold text-center text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-500 dark:hover:bg-blue-600 dark:focus:ring-blue-800"
       >
        Login now
      </a>
      <button (click)="closeDialog()"
        class="inline-flex items-center justify-center w-full h-[35px] px-2 py-1.5 text-sm font-semiboldtext-center text-gray-900 border border-gray-300 rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 dark:text-white dark:border-gray-700 dark:hover:bg-gray-500 dark:focus:ring-gray-600">
        Got it, thanks!
      </button>
    </div>
  </div>
</mat-dialog-content>